import axios from "axios";

const API_KEY = process.env.REACT_APP_API_KEY;

const difficultyMap = {
  easy: "kolay (temel bilgi düzeyinde, herkesin cevaplayabileceği)",
  medium: "orta (genel kültür düzeyinde, biraz düşünme gerektiren)",
  hard: "zor (detaylı bilgi gerektiren, uzmanların cevaplayabileceği)"
};

export const fetchQuizQuestions = async (topic, difficulty = "medium", questionCount = 10) => {
  const apiUrl = `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash:generateContent?key=${API_KEY}`;

  const difficultyText = difficultyMap[difficulty] || difficultyMap.medium;

  const prompt = `
    "${topic}" hakkında ${questionCount} tane çoktan seçmeli soru oluştur.
    Zorluk seviyesi: ${difficultyText}.

    Her soru için şu formatı AYNEN kullan:

    Soru: [Soru metni, konuya uygun ve net olmalı]
    A) [Mantıklı ve gerçekçi bir seçenek]
    B) [Kısmen doğru veya konuya uygun başka bir seçenek]
    C) [Yanıltıcı ama konuyla alakalı bir seçenek]
    D) [Açıkça yanlış veya zıt bir seçenek]
    Doğru Cevap: [A/B/C/D]

    ÖNEMLİ KURALLAR:
    - Her soruyu ayrı bir paragrafta yaz (aralarında boş satır bırak).
    - Seçenekler "option1" gibi varsayılan ifadeler içermemeli.
    - Seçeneklerin birbirine yakın mantıkta ve konuyla alakalı olmasına dikkat et.
    - Doğru cevap her seferinde farklı şıklarda olsun (hep A olmasın).
    - Soru numarası yazma, sadece "Soru:" ile başla.
    - Başka hiçbir açıklama veya yorum ekleme.
  `;

  const payload = {
    contents: [{
      parts: [{
        text: prompt
      }]
    }]
  };

  try {
    const response = await axios.post(apiUrl, payload, {
      headers: {
        "Content-Type": "application/json",
      }
    });

    const rawText = response.data.candidates[0].content.parts[0].text;
    const parsed = parseQuestionsEnhanced(rawText);
    const valid = parsed.filter(q => q.question !== 'Soru yüklenemedi' && q.options.length === 4);

    if (valid.length === 0) {
      throw new Error("Sorular düzgün oluşturulamadı.");
    }

    return valid;
  } catch (error) {
    console.error("Quiz soruları oluşturulurken hata:", error);
    throw new Error("Quiz soruları oluşturulamadı. Lütfen tekrar deneyin.");
  }
};

const parseQuestionsEnhanced = (rawText) => {
  const questionBlocks = rawText.split(/\n\s*\n/).filter(block => block.trim());

  return questionBlocks.map(block => {
    const lines = block.split('\n').map(line => line.trim());

    const questionLine = lines.find(line => line.startsWith('Soru:'));
    const question = questionLine ? questionLine.replace('Soru:', '').trim() : 'Soru yüklenemedi';

    const options = lines
      .filter(line => /^[A-D]\)/.test(line))
      .map(line => {
        const text = line.replace(/^[A-D]\)/, '').trim();
        return {
          text: text || 'Seçenek yüklenemedi',
          isCorrect: false
        };
      });

    const correctAnswerLine = lines.find(line => line.startsWith('Doğru Cevap:'));
    if (correctAnswerLine) {
      const correctLetter = correctAnswerLine.replace('Doğru Cevap:', '').trim();
      const correctIndex = correctLetter.charCodeAt(0) - 'A'.charCodeAt(0);
      if (options[correctIndex]) {
        options[correctIndex].isCorrect = true;
      }
    }

    if (options.length !== 4) {
      return { question, options: [] };
    }

    if (!options.some(opt => opt.isCorrect)) {
      options[0].isCorrect = true;
    }

    return { question, options };
  });
};
